var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from '@/setup/axios';
import { showAlert, showLoading, showProgress } from '@/helpers';
import moment from 'moment';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { trans } from '@/setup/locales';
let Boxes = class Boxes extends Vue {
    constructor() {
        super(...arguments);
        this.loaded = false;
        this.tourGroup = null;
        this.recipes = [];
        this.recipe = null;
        this.saved = [];
    }
    get tourDate() {
        return moment(this.date);
    }
    mounted() {
        this.initEvent();
        this.loadRecipes();
    }
    initEvent() {
        window.onbeforeunload = e => {
            if (!this.isReadonly && (this.saved.length !== 0 || this.recipe !== null)) {
                e.preventDefault();
                e.returnValue = '';
                return trans('tour.repartition.dirty');
            }
        };
    }
    reload() {
        return __awaiter(this, void 0, void 0, function* () {
            this.loaded = false;
            this.tourGroup = null;
            this.recipes = [];
            this.recipe = null;
            this.saved = [];
            this.loadRecipes();
        });
    }
    loadRecipes() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.tourDate === null) {
                return;
            }
            showLoading(true);
            let withMarketProductionCoefficientsUrlParam = '';
            if (!this.isReadonly) {
                withMarketProductionCoefficientsUrlParam = '?withMarketProductionCoefficients=1';
            }
            const { data } = yield axios.get(`/worker/boxes/show/${this.tourDate.format()}` + withMarketProductionCoefficientsUrlParam);
            this.loaded = true;
            if (typeof data.tour_group === 'undefined' || data.tour_group === null) {
                showLoading(false);
                return;
            }
            const { tour_group, recipes } = data;
            this.tourGroup = tour_group;
            const recipeCount = recipes.length;
            let current = 0;
            for (const recipe of recipes) {
                showProgress(true, 100 / recipeCount * current++);
                const { data, } = yield axios.get(`/worker/boxes/show/${tour_group}/${recipe.id}` + withMarketProductionCoefficientsUrlParam);
                recipe.data = data;
                this.recipes.push(recipe);
            }
            showProgress(false);
        });
    }
    online() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!navigator.onLine) {
                return false;
            }
            try {
                yield axios.get('/');
                return true;
            }
            catch (error) {
                return false;
            }
        });
    }
    sync() {
        return __awaiter(this, void 0, void 0, function* () {
            const online = yield this.online();
            if (!online) {
                showAlert(trans('tours.repartition.offline'));
                return;
            }
            showLoading(true);
            const { data: { success } } = yield axios.post(`/worker/boxes/show/${this.tourGroup}`, {
                recipes: this.saved.map(recipe => { return { id: recipe.id, quality: recipe.quality }; })
            });
            showLoading(false);
            if (success) {
                this.reload();
            }
        });
    }
    onRecipeCancel() {
        this.recipe = null;
        showLoading(false);
    }
    onRecipeSave(recipe, quality) {
        if (!this.isReadonly) {
            recipe.finished = true;
            recipe.quality = quality;
            this.recipes = this.recipes.map(rec => rec.id === recipe.id ? recipe : rec);
            this.saved.push(recipe);
        }
        this.recipe = null;
        showLoading(false);
    }
};
__decorate([
    Prop()
], Boxes.prototype, "date", void 0);
__decorate([
    Prop({ default: false })
], Boxes.prototype, "isReadonly", void 0);
Boxes = __decorate([
    Component
], Boxes);
export default Boxes;
